import React from 'react';
import DropdownMenuProvider from './DropdownMenuProvider.js';
import DropdownMenuRenderer from './DropdownMenuRenderer.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@elliemae/ds-utilities/utils';
import './DropdownMenuContext.js';
import '@babel/runtime/helpers/esm/extends';
import '@elliemae/ds-utilities/getComponentFromProps';
import '@elliemae/ds-basic/Popper';
import '@elliemae/ds-basic/Menu';
import '@elliemae/ds-classnames';
import './decoratedMenuItemFactory.js';
import './MenuItemClickableHOC.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import './MenuItemGroupSelectionHOC.js';
import './DropdownMenuLoadingIndicator.js';
import 'styled-components';
import '@elliemae/ds-basic/CircularProgressIndicator';

function DropdownMenuWrapper(props) {
  return /*#__PURE__*/React.createElement(DropdownMenuProvider, props, /*#__PURE__*/React.createElement(DropdownMenuRenderer, props));
}

export default DropdownMenuWrapper;
//# sourceMappingURL=DropdownMenuWrapper.js.map
